import { FormattedMessage } from 'react-intl'
import { clsx } from 'clsx'

import { Badge } from 'Components/_theme'

import { DeviceHealthStatus } from './deviceHealth.types'
import type { DeviceHealthStatusBadgeProps } from './DeviceHealthStatusBadge.types'

const DEVICE_HEALTH_STATUS_BADGE_COLOR_MAP = {
  [DeviceHealthStatus.Healthy]: 'green',
  [DeviceHealthStatus.Attention]: 'orange',
} as const

const DEVICE_HEALTH_STATUS_BADGE_TRANSLATION_IDS = {
  [DeviceHealthStatus.Healthy]: 'DeviceHealth_status_healthy',
  [DeviceHealthStatus.Attention]: 'DeviceHealth_status_attention',
} as const

export const DeviceHealthStatusBadge = (
  props: DeviceHealthStatusBadgeProps,
) => {
  const { status, className } = props

  return (
    <Badge
      className={className}
      color={DEVICE_HEALTH_STATUS_BADGE_COLOR_MAP[status]}
      variant="secondary"
    >
      <span
        className={clsx(
          'DeviceHealthStatusBadge-dot',
          status === DeviceHealthStatus.Attention &&
            'DeviceHealthStatusBadge-dot--attention',
        )}
      />

      <FormattedMessage
        id={DEVICE_HEALTH_STATUS_BADGE_TRANSLATION_IDS[status]}
      />
    </Badge>
  )
}
